import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

/**
 * Password input with a show/hide toggle (Stuart, 11 Jun — "annoying typing
 * it in and getting it wrong all the time"). Drop-in replacement for
 * <input type="password">: all props pass through; the eye button swaps the
 * input between password and text.
 *
 * tabIndex={-1} on the button keeps keyboard flow natural (Tab goes from
 * password straight to the next field, not to the eye).
 */
const PasswordInput = ({ className = 'input', style, ...props }) => {
  const [show, setShow] = useState(false);
  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <input
        {...props}
        type={show ? 'text' : 'password'}
        className={className}
        style={{ ...style, paddingRight: 42, width: '100%', boxSizing: 'border-box' }}
      />
      <button
        type="button"
        tabIndex={-1}
        aria-label={show ? 'Hide password' : 'Show password'}
        title={show ? 'Hide password' : 'Show password'}
        onClick={() => setShow(s => !s)}
        style={{
          position: 'absolute', right: 6, top: '50%', transform: 'translateY(-50%)',
          background: 'none', border: 'none', cursor: 'pointer', padding: 8,
          minWidth: 40, minHeight: 40, justifyContent: 'center',
          display: 'flex', alignItems: 'center', color: 'var(--text-secondary, #888)',
        }}
      >
        {/* Inline position/pointer-events overrides: some containers (e.g. the
            platform login's .input-with-icon) style ALL child svgs with
            position:absolute + pointer-events:none, which strands and disables
            the eye. Inline styles win over those rules. */}
        {show
          ? <EyeOff size={20} style={{ position: 'static', pointerEvents: 'auto' }} />
          : <Eye size={20} style={{ position: 'static', pointerEvents: 'auto' }} />}
      </button>
    </div>
  );
};

export default PasswordInput;
